export { organizationImage, getOrganizationIcon } from './organization-image';
